import React, { useEffect, useRef, useState } from 'react';
import { setSessionStorageItem, getSessionStorageItem, SESSION_STORAGE_EMAIL_CAPTURE } from '../../../../sessionStorage';
import SvgIcon from '@material-ui/core/SvgIcon';
import SaveTermQuoteIcon from '../../../../icons/SaveTermQuote.svg';
import { makeStyles } from "@material-ui/core/styles";
import './SaveQuoteButton.scss';
import SaveQuote from './SaveQuote';
import { Button } from '@material-ui/core';
import { saveQuoteMessage } from './SaveQouteMessage';

const white = "#ffffff";
const offWhite = "rgba(0, 0, 0, 0.01)";

const useStyles = makeStyles(theme => ({
    white: {
        color: theme.palette.primary.main,
        backgroundColor: white,
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: offWhite
        },
        '&:focus': {
            outline: 'none'
        }
    },
    lightBackground: {
        backgroundColor: `${theme.palette.primary.main}16`,
    },
}));

export default function SaveQuoteButton(props) {
    const classes = useStyles();

    const title = props.title || "NEEDS ANALYSIS";
    const emailCaptureObj = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);

    const [modalSaveQuoteIsOpen, setModalSaveQuoteIsOpen] = useState(false);
    const [saveType, setSaveType] = useState(null);
    const [saveMessage, setSaveMessage] = useState(null);
    const inactivityTimerId = useRef(null);
    const inactivityDuration = (5 * 60 * 1000);

    const {enableInitialEmailCapture, enableTimeoutEmailCapture, initialEmailCaptureDisplayed, timeoutEmailCaptureDisplayed} = props.setEmailModal;

    const handleInactivity = () => {
        const newEmailCaptureObj = {
            enableInitialEmailCapture: enableInitialEmailCapture,
            enableTimeoutEmailCapture: enableTimeoutEmailCapture,
            initialEmailCaptureDisplayed: initialEmailCaptureDisplayed,
        }
        setSaveType("timeout");
        setModalSaveQuoteIsOpen(true);
        removeTimeoutListener();
        setSessionStorageItem("EMAIL_CAPTURE", {...newEmailCaptureObj, timeoutEmailCaptureDisplayed: true });
        props.setTimeoutEmailDisplayed();
    };

    const handleSaveModalClick = () => {
        if (props.isQuoteSaved) {
            setSaveType("update");
        } else {
            setSaveType(null);
        }
        setModalSaveQuoteIsOpen(true);
    };

    const setTimerId = () => {
        if (inactivityTimerId.current) {
            clearTimeout(inactivityTimerId.current);
        }
        
        inactivityTimerId.current = setTimeout(handleInactivity, inactivityDuration);
    };

    const removeTimeoutListener = () => {
        clearTimeout(inactivityTimerId.current);
        window.removeEventListener("mousemove", setTimerId);
        window.removeEventListener("mousedown", setTimerId);
        window.removeEventListener("keypress", setTimerId);
        window.removeEventListener("scroll", setTimerId);
    };

    useEffect(() => {
        if (!props.isActivePurl && enableInitialEmailCapture && !initialEmailCaptureDisplayed) {
            setModalSaveQuoteIsOpen(true);
            setSaveType(null);
            setSessionStorageItem("EMAIL_CAPTURE", {...emailCaptureObj, initialEmailCaptureDisplayed: true});
            props.setInitialEmailDisplayed();
        }
    }, []);

    useEffect(() => {
        const email = props.saveQuoteData ? props.saveQuoteData.emailAddress : "";
        const message = saveQuoteMessage(saveType, email);
        setSaveMessage(message, email);
    }, [saveType, props.saveQuoteData]);

    useEffect(() => {
        if (!props.isQuoteSaved && !modalSaveQuoteIsOpen && enableTimeoutEmailCapture && !timeoutEmailCaptureDisplayed) {
            window.addEventListener("mousemove", setTimerId);
            window.addEventListener("mousedown", setTimerId);
            window.addEventListener("keypress", setTimerId);
            window.addEventListener("scroll", setTimerId);
    
            setTimerId();
        } else {
            removeTimeoutListener();
        }
        return () => {
            removeTimeoutListener();
        }
    }, [modalSaveQuoteIsOpen]);

    const modalSaveTermQuoteFields = {
        modalSaveQuoteIsOpen: modalSaveQuoteIsOpen,
        setModalSaveQuoteIsOpen: setModalSaveQuoteIsOpen,
        loading: props.loading,
        quoteLogId: props.quoteLogId,
        errorMessage: props.errorMessage,
        setErrorMessage: props.setErrorMessage,
    };

    return (
        <div className="save-term-quote-btn">
            <React.Fragment>
                <Button type="button"
                    onClick={() => handleSaveModalClick() }
                    variant="contained"
                    color="primary"
                    className={`save-term-button ${classes.white}`}
                >
                    <span className="name">&nbsp;{title}</span> <span className="icon"><SvgIcon component={SaveTermQuoteIcon} color="primary" /></span>
                </Button>
                <SaveQuote 
                    setEmailPrefill={(e) => props.setEmailPrefill(e)} 
                    setQuoteEmail={() => props.setQuoteEmail()} 
                    fields={modalSaveTermQuoteFields} 
                    saveMessage={saveMessage} 
                    saveQuoteData={props.saveQuoteData}
                    setQuoteSaved={props.setQuoteSaved}
                    isQuoteSaved={props.isQuoteSaved}
                    handleContactChange={(e) => props.handleContactChange(e)}/>
            </React.Fragment>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/SaveTermQuote/SaveQuoteButton.js